export const allocationPaletteSwatches = [
  "#9d3444", "#a44928", "#9a6a16", "#4f7d3a", "#168760", "#277a75",
  "#276f8c", "#2267b8", "#4058a6", "#6d3aa6", "#8d3d78", "#8a465f",
  "#7c2d35", "#8b3f20", "#826018", "#3e6a32", "#126e50", "#23645f",
  "#205d75", "#1c5598", "#34498b", "#5a2f8d", "#743464", "#713a50",
  "#596a7c", "#46586d", "#35475b", "#26394d", "#172a3b", "#0d1f30"
] as const;

export const defaultAllocationLabelColor = allocationPaletteSwatches[0];
